/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */
export const supportsFlags: Record<string, boolean | undefined> = {}
